<template>
  <v-radio-group class="pa-0 ma-0 pb-1" hide-details :value="value">
    <v-radio
      v-for="item in options"
      class="pa-0 ma-0 py-2"
      :key="item.id"
      :value="item.id"
      @click="$emit('change', item.id)"
    >
      <template v-slot:label>
        <p
          class="font-size-13 blue-grey--text text--darken-3 ma-0 pa-0 font-weight-500 ms-2"
        >
          {{ item.text }}
        </p>
      </template>
    </v-radio>
  </v-radio-group>
</template>

<script>
export default {
  name: 'RadioFilter',

  props: {
    options: { type: Array, default: () => [] },
    value: { type: String, default: null },
  },
}
</script>
